import type { HiddenInboxItem } from '../api/types.js';
import { parisWhen } from './paris-time.js';

/** Why a decision is out of « Waiting on you », and when it comes back: the same line on the list and on its page */
export function hiddenLine(h: HiddenInboxItem['hidden']): string {
  if (h.state === 'dismissed') return 'Already done elsewhere: comes back if it changes';
  if (h.state === 'snoozed') return `Snoozed until ${parisWhen(h.until ?? h.at)}`;
  const why = h.reason ? `${h.reason.charAt(0).toUpperCase()}${h.reason.slice(1)}` : 'Set aside';
  if (h.byAidev) return `${why}: set aside by aidev`;
  return `${why}. Comes back when it changes${h.until ? `, or on ${parisWhen(h.until)}` : ''}`;
}
